import { Button } from "primereact/button";
import React, { useState } from "react";
import "./TooltipAlias.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faApple, faWindows } from "@fortawesome/free-brands-svg-icons";
import { FormattedMessage } from "react-intl";

function Tooltip() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleTooltip = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div style={{ position: "relative" }}>
      <Button
        icon="pi pi-question-circle"
        onClick={toggleTooltip}
        className="readysize-tooltip-container"
      />

      {isVisible && (
        <div
          className="tooltip-content"
          style={{
            position: "absolute",
            backgroundColor: "white",
            padding: "15px 20px 15px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            zIndex: 1000,
            right: "0px",
            left: "50px",
            width: "400px",
            height: "auto",
            top: "-70px",
          }}
        >
          <div>
            <p>
              <FormattedMessage
                id="aliasTooltip"
                defaultMessage="Podes agregar mas sitios a tu administrador"
              />
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tooltip;
